import React, { memo } from 'react';
import { exhaustiveCheck } from '@direct-frontend/stdlib';

import { cn } from '../../lib/css/className/className';

import './LineBreak.css';

const cls = cn('LineBreak');

/** Пропсы компонента переноса строки */
export interface LineBreakProps {
    /**
     * Режим отображения переноса строки
     * 'normal' - нормальный режим, используется для перехода к новому абзацу – аналог enter
     * 'compact' - компактный режим, используется для перехода к новой строке – аналог shift+enter
     * @default 'normal'
     */
    mode?: 'normal' | 'compact';
}

/**
 * Компонент переноса строки
 * @kind component
 * @example
 * ```tsx
 * <Paragraph size="m">
 *     i18n('Большой текст первого абзаца...')
 *     <LineBreak />
 *     i18n('Большой текст второго абзаца...')
 *     <LineBreak />
 *     i18n('Большой текст третьего абзаца...')
 * </Paragraph>
 *
 * <Text>
 *     {i18nRaw('Абзац 1{lineBreak}Абзац 2', { lineBreak: <LineBreak /> })}
 * </Text>
 *
 * <Text>
 *     {i18nRaw('Текст{lineBreak}С новой строки', { lineBreak: <LineBreak mode="compact" /> })}
 * </Text>
 * ```
 */
export const LineBreak = memo<LineBreakProps>(function HeaderStub({ mode = 'normal' }) {
    switch (mode) {
        case 'compact':
            return <br />;
        case 'normal':
            return (
                <>
                    <br />
                    <span className={cls({ mode })}>{''}</span>
                </>
            );
        default:
            exhaustiveCheck(mode, 'Unsupported LineBreak mode');
    }
});
